
import { defineComponent } from 'vue'

// presentation information
interface PresentationInfo {
  title: string,
  author: string,
  conference: string,
  location: string,
  date: string,
  invited: boolean,
  number?: string,
  note?: string
}

export default defineComponent({
  data () {
    return {
      presentations: [
        {
          title: '多極⼦と共存・競合する超伝導に関する微視的理論の構築',
          author: '<u>角田 峻太郎</u>',
          conference: '「アシンメトリが彩る量⼦物質の可視化・設計・創出」令和8年度 領域全体会議',
          location: 'ラフォーレ那須(講演はオンライン)',
          date: '2026年5月',
          invited: false
        },
        {
          title: '多極子秩序と共存・競合するエキゾチック超伝導の理論的提案',
          author: '<u>角田 峻太郎</u>',
          conference: '日本物理学会 2026年春季大会',
          location: 'オンライン開催(Zoom)',
          date: '2026年3月',
          invited: false,
          number: '24aH1-3',
          note: '(若手奨励賞受賞記念講演)'
        },
        {
          title: '量子輸送方程式に基づくカイラル金属中の電磁場応答の考察',
          author: '<u>角田 峻太郎</u>',
          conference: '第10回 凝縮系理論の最前線',
          location: 'ニューウェルシティ湯河原',
          date: '2026年2月',
          invited: true
        },
        {
          title: '量子輸送方程式に基づくカイラリティ誘起スピン分極の考察',
          author: '<u>角田 峻太郎</u>',
          conference: 'カイラル物質と量子輸送に関する理論研究会',
          location: 'KKRホテル熱海',
          date: '2026年2月',
          invited: false
        },
        {
          title: '交替磁性と共存する空間変調超伝導の理論',
          author: '<u>角田 峻太郎</u>',
          conference: '新規超伝導体を舞台とする超伝導科学のフロンティア',
          location: '京都大学基礎物理学研究所',
          date: '2025年12月',
          invited: true
        },
        {
          title: '固体中におけるフォノン・電子間の角運動量変換の理論',
          author: '<u>角田 峻太郎</u>，加藤 雄介',
          conference: '日本物理学会 第80回年次大会',
          location: '広島大学',
          date: '2025年9月',
          invited: false,
          number: '16aSK302-12'
        },
        {
          title: 'Ginzburg–Landau理論に基づく交替磁性誘起FFLO超伝導の理解',
          author: '<u>角田 峻太郎</u>，中 惇，妹尾 仁嗣',
          conference: '日本物理学会 2025年春季大会',
          location: 'オンライン開催(Zoom)',
          date: '2025年3月',
          invited: false,
          number: '18pH2-7'
        },
        {
          title: '交替磁性と空間変調超伝導の相関',
          author: '<u>角田 峻太郎</u>，中 惇，妹尾 仁嗣',
          conference: '超伝導研究の新潮流',
          location: '京都大学基礎物理学研究所',
          date: '2024年12月',
          invited: false
        },
        {
          title: '遍歴強相関電子系における多極子秩序の理論',
          author: '<u>角田 峻太郎</u>',
          conference: '<a href="https://asymmetry.hiroshima-u.ac.jp/event/1097" target="_blank">アシンメトリ量子若手秋の学校</a>',
          location: '国立大雪青少年交流の家',
          date: '2024年9月',
          invited: true,
          note: `<a href="slides/slide_20240921.pdf" target="_blank">講義スライド</a> (念のため，2次配布はご遠慮ください．)<br/>
          <a href="https://github.com/shuntarosumita/asymmetry_autumn_school_2024" target="_blank">副教材プログラム(Julia)</a>`
        },
        {
          title: '交替磁性と超伝導の相関 —スピン軌道結合の効果—',
          author: '<u>角田 峻太郎</u>，中 惇，妹尾 仁嗣',
          conference: '日本物理学会 第79回年次大会',
          location: '北海道大学',
          date: '2024年9月',
          invited: false,
          number: '19aE306-8'
        },
        {
          title: '交替磁性に誘起されるFFLO超伝導',
          author: '<u>角田 峻太郎</u>',
          conference: '核子系と電子系における対相関と対凝縮相',
          location: '大阪大学 核物理研究センター',
          date: '2024年9月',
          invited: true
        },
        {
          title: '横磁場中の異方的反強磁性スピン鎖におけるスピンパリティ効果と対称性',
          author: '<u>角田 峻太郎</u>，田中 秋広，加藤 雄介',
          conference: '日本物理学会 2024年春季大会',
          location: 'オンライン開催(Zoom)',
          date: '2024年3月',
          invited: false,
          number: '19aL2-7'
        },
        {
          title: '&kappa;-(ET)<sub>2</sub><i>X</i>の磁気八極子状態におけるFFLO超伝導',
          author: '<u>角田 峻太郎</u>，中 惇，妹尾 仁嗣',
          conference: '日本物理学会 2024年春季大会',
          location: 'オンライン開催(Zoom)',
          date: '2024年3月',
          invited: false,
          number: '18pH1-8'
        },
        {
          title: '高次磁気多極子と超伝導',
          author: '<u>角田 峻太郎</u>',
          conference: '若手理論交流研究会〜物性研究における最近の進展',
          location: '富山県立大学',
          date: '2023年12月',
          invited: true
        },
        {
          title: '反強磁性スピン鎖における異方性誘起スピンパリティ効果',
          author: '<u>角田 峻太郎</u>，田中 秋広，加藤 雄介',
          conference: '日本物理学会 第78回年次大会',
          location: '東北大学',
          date: '2023年9月',
          invited: false,
          number: '18pB103-7'
        },
        {
          title: '&kappa;系有機導体における反強磁性誘起FFLO超伝導',
          author: '<u>角田 峻太郎</u>，中 惇，妹尾 仁嗣',
          conference: '日本物理学会 2023年春季大会',
          location: 'オンライン開催(Zoom)',
          date: '2023年3月',
          invited: false,
          number: '25pG1-5'
        },
        {
          title: '空間反転対称性が破れた系における超伝導電流誘起Weyl超伝導',
          author: '<u>角田 峻太郎</u>，高三 和晃',
          conference: '日本物理学会 第77回年次大会',
          location: 'オンライン開催(Zoom)',
          date: '2022年3月',
          invited: false,
          number: '15pT24-3'
        },
        {
          title: '対称性と群の表現論に基づく超伝導ギャップ・ノード構造の分類理論',
          author: '<u>角田 峻太郎</u>',
          conference: '<a href="https://www.ms.u-tokyo.ac.jp/~yasuyuki/crest2022.htm" target="_blank">CRESTチュートリアル・ワークショップ「物質のトポロジカル相の理論的探究」</a>',
          location: 'オンライン開催(Zoom)',
          date: '2022年2月',
          invited: true,
          note: '<a href="notes/gap_classification_rep.pdf" target="_blank">講義ノート</a> (念のため，2次配布はご遠慮ください．)'
        },
        {
          title: 'トポロジカルなSNS接合系の再考：分数ジョセフソン電流・フェルミオンパリティ・波動関数の振動',
          author: '<u>角田 峻太郎</u>，古崎 昭',
          conference: '非自明な電子状態が生み出す超伝導現象の最前線：新たな挑戦と展望',
          location: '京都大学基礎物理学研究所',
          date: '2021年12月',
          invited: false
        },
        {
          title: 'トポロジカル超伝導体を用いたSNS接合系における分数ジョセフソン効果の増強',
          author: '<u>角田 峻太郎</u>，古崎 昭',
          conference: '日本物理学会 2021年秋季大会',
          location: 'オンライン開催(Zoom)',
          date: '2021年9月',
          invited: false,
          number: '20pD1-3'
        },
        {
          title: '多極子揺らぎを起源とする異方的超伝導理論',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '日本物理学会 2020年秋季大会',
          location: 'オンライン開催(Zoom)',
          date: '2020年9月',
          invited: false,
          number: '11aH2-12'
        },
        {
          title: '多極子揺らぎに媒介される非従来型超伝導機構',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '日本物理学会 第75回年次大会',
          location: '名古屋大学',
          date: '2020年3月',
          invited: false,
          number: '18pB21-3',
          note: '(<a href="https://www.jps.or.jp/activities/meetings/2020annual/corona/files/mail20200227.pdf" target="_blank">現地開催中止のため講演概要により発表成立</a>)'
        },
        {
          title: '波数基底の多極子揺らぎに媒介される超伝導',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '電子相関が生み出す超伝導現象の未解決問題と新しい潮流',
          location: '京都大学基礎物理学研究所',
          date: '2019年10月',
          invited: false
        },
        {
          title: '波数基底の多極子揺らぎに誘起される超伝導',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '日本物理学会 2019年秋季大会',
          location: '岐阜大学',
          date: '2019年9月',
          invited: false,
          number: '12aB11-6'
        },
        {
          title: '波数基底の多極子揺らぎが媒介する異方的超伝導',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: 'J-Physics 地域研究会─大阪',
          location: '大阪大学',
          date: '2019年7月',
          invited: false
        },
        {
          title: '高対称線上におけるトポロジカル結晶超伝導ノードの分類',
          author: '<u>角田 峻太郎</u>，野本 拓也，塩崎 謙，栁瀬 陽一',
          conference: '日本物理学会 第74回年次大会',
          location: '九州大学',
          date: '2019年3月',
          invited: false,
          number: '15aS301-6',
          note: '<b><a class="text-success" href="https://www.jps.or.jp/activities/awards/gakusei/2019a-student-presentation-award.php" target="_blank">学生優秀発表賞(領域8)</a></b>'
        },
        {
          title: '3回回転対称性に守られた角運動量に依存するノードのある超伝導',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '電子相関が生み出す新規な秩序と超伝導現象：トポロジー，液晶状態，動的現象',
          location: '京都大学基礎物理学研究所',
          date: '2018年5月',
          invited: false
        },
        {
          title: '3回回転対称性がある系における角運動量に依存するWeyl超伝導状態',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '日本物理学会 第73回年次大会',
          location: '東京理科大学',
          date: '2018年3月',
          invited: false,
          number: '23pB101-2'
        },
        {
          title: '奇パリティ拡張磁気多極子状態におけるFFLO超伝導',
          author: '<u>角田 峻太郎</u>',
          conference: 'J-Physicsトピカルミーティング「どう創る？：キラル磁性体と拡張多極子」',
          location: '兵庫県立淡路夢舞台国際会議場',
          date: '2018年1月',
          invited: false
        },
        {
          title: '空間群によって守られる非自明な超伝導ギャップノード',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '日本物理学会 2017年秋季大会',
          location: '岩手大学',
          date: '2017年9月',
          invited: false,
          number: '21aF21-13'
        },
        {
          title: 'イリジウム酸化物Sr<sub>2</sub>IrO<sub>4</sub>における多極子超伝導',
          author: '<u>角田 峻太郎</u>，野本 拓也，栁瀬 陽一',
          conference: '超伝導研究の最先端：多自由度，非平衡，電子相関，トポロジー，人工制御',
          location: '京都大学基礎物理学研究所',
          date: '2017年6月',
          invited: false
        },
        {
          title: 'Sr<sub>2</sub>IrO<sub>4</sub>における非共型対称性に守られたノードのある超伝導と磁気四極子によるFFLO超伝導',
          author: '<u>角田 峻太郎</u>，野本 拓也，栁瀬 陽一',
          conference: '日本物理学会 第72回年次大会',
          location: '大阪大学',
          date: '2017年3月',
          invited: false,
          number: '17pL22-6'
        },
        {
          title: '磁気多極子状態における超伝導',
          author: '<u>角田 峻太郎</u>，栁瀬 陽一',
          conference: '日本物理学会 第71回年次大会',
          location: '東北学院大学',
          date: '2016年3月',
          invited: false,
          number: '21aBM-3'
        }
      ] as PresentationInfo[]
    }
  }
})
